import { FirebaseOptions } from '@angular/fire';
import * as config from './firebase-config.json';

export class FirebaseConfigHelper {
  static getConfig(): FirebaseOptions {
    return config.default;
  }
}
